<template>
  <div>
    <div v-if="model != null">
<!--      <van-cell-group style="margin-top: 20px;">-->
<!--        <van-cell title="当前状态" is-link @click="statusActionSheet.show = true">-->
<!--            <span v-if="model.status == 1 && model.isVoiceActivated" class="text-green">在线 - 开启语音</span>-->
<!--            <span v-else-if="model.status == 1 && !model.isVoiceActivated" class="text-orange">在线 - 关闭语音</span>-->
<!--            <span v-else class="text-gray">离线</span>-->
<!--        </van-cell>-->
<!--      </van-cell-group>-->

      <van-cell-group >
          <van-cell v-if=" $ClerkPermission.modifiableClerkAttr.includes('name')" title="名称" :value="model.name" is-link clickable @click="updateNameDialog.name = model.name;updateNameDialog.show = true" />
          <van-cell v-else title="名称" :value="model.name" />
          <van-cell title="头像" center is-link clickable @click="model.picStatus !== 0 ?chooseImage(changeAvatar) : ''">
            <van-tag v-if="this.model.picStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            <img :src="model.avatarUrl" width="40" height="40" style="border-radius: 5px;" />
          </van-cell>
          <van-cell title="相册" title-style="flex:none;" center is-link clickable :to="this.model.photoStatus != 0 ? '/clerk/updatePhotos' : ''">
            <van-tag v-if="this.model.photoStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            <img v-for="(item, index) in model.photoUrls" :src="item" width="40" height="40" style="border-radius: 5px;margin-left: 2px;" />
          </van-cell>
          <van-cell title="录音" is-link clickable :to="this.model.soundStatus != 0 ? '/clerk/updateAudio' : ''">
            <van-tag v-if="this.model.soundStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
            <span v-if="model.audioUrl == null || model.audioUrl == ''" >未上传录音</span>
              <van-button v-else class="btn-play-audio" size="mini" color="#666" plain @click.stop="playAudio(model.id, model.audioUrl)">
                  <div class="flex align-center">
                      <img :src="player.id == model.id ? iconAudioPlaying : iconAudio">{{player.id == model.id ? '停止' : '播放'}}
                  </div>
              </van-button>
          </van-cell>
<!--        <van-cell v-if="hasSoundList"  title="声音" :value="clerkSoundIds? clerkSoundIds.length + '个': '未设置'" is-link clickable to="/clerk/updateSound" />-->
          <van-cell title="等级" :value="$store.state.ClerkGradeMap[model.grade]" />
        <van-cell v-if=" $ClerkPermission.modifiableClerkAttr.includes('sex') && isEdit" title="性别" :value="$store.state.ClerkSexEnum.getLabel(model.sex) || '未设置'" is-link clickable @click="clickUpdateSex" />
        <van-cell v-else title="性别" :value="$store.state.ClerkSexEnum.getLabel(model.sex) || '未设置'" />
<!--          <van-cell title="年龄" :value="model.age != null ? model.age : '未设置'" is-link clickable @click="updateAgeDialog.age = model.age;updateAgeDialog.show = true" />-->
          <van-cell title="个性签名" :value="model.signature || '未设置'" is-link clickable
                    @click="()=>{if(model.signatureStatus !== 0){updateSignatureDialog.signature = model.signature;updateSignatureDialog.show = true}}">
        <van-tag v-if="this.model.signatureStatus == 0" plain type="primary" class="margin-right-xs">待审核</van-tag>
        {{model.signature || '未设置'}}
        </van-cell>
<!--          <van-cell title="地区" :value="model.regionNames.length > 0 ? model.regionNames.join('-') : '未设置'" is-link clickable @click="areasPicker.show = true" />-->
        <van-cell title="微信工资收款码" center clickable @click="()=>{this.codeType = 'wechat';chooseImage(updatePaymentCode)}">
          <span v-if="_.has(model,'paymentQRCodeUrls.wechat')">修改</span>
          <span v-else>上传</span>
        </van-cell>
        <van-cell title="实名认证" is-link center @click="openVerify">
          <template v-if="!model.requireVerify">
            <span>无需认证</span>
          </template>
          <template v-else>
            <span>{{model.isVerified? '已认证':'未认证'}}</span>
          </template>
        </van-cell>
      </van-cell-group>
    </div>

      <!-- 选择性别 -->
      <van-action-sheet
              v-model="sexActionSheet.show"
              title="修改性别"
              round
              :actions="sexActionSheet.actions"
              @select="onSexActionSheetSelect"
      />

    <!-- 修改名称 -->
    <van-dialog
          v-model="updateNameDialog.show"
          title="修改名称"
          show-cancel-button
          :beforeClose="onUpdateNameDialogClose">
        <div class="padding-top-sm">
            <van-field v-model="updateNameDialog.name"
                       placeholder="请输入名称"
                       maxlength="10"
                       style="background: #f5f5f5;" />
        </div>
    </van-dialog>

      <!-- 修改年龄 -->
      <van-dialog
              v-model="updateAgeDialog.show"
              title="修改年龄"
              show-cancel-button
              :beforeClose="onUpdateAgeDialogClose">
          <div class="padding-top-sm">
              <van-field v-model="updateAgeDialog.age"
                         placeholder="请输入年龄"
                         maxlength="10"
                         style="background: #f5f5f5;" />
          </div>
      </van-dialog>

    <!-- 修改个性签名 -->
    <van-dialog
          v-model="updateSignatureDialog.show"
          title="修改个性签名"
          show-cancel-button
          :beforeClose="onUpdateSignatureDialogClose">
        <div class="padding-top-sm">
          <van-field v-model="updateSignatureDialog.signature"
                     type="textarea"
                     rows="2"
                     placeholder="请输入个性签名"
                     maxlength="30"
                     style="background: #f5f5f5;" />
        </div>
    </van-dialog>

    <!-- 修改头像 -->
    <van-dialog
          v-model="updateAvatarDialog.show"
          title="修改头像"
          show-cancel-button
          :beforeClose="updateAvatar">
      <div class="padding-tb-sm text-center">
          <img class="upload-img-preview" :src="updateAvatarDialog.avatar" >
      </div>
    </van-dialog>

    <!-- 选择图片 -->
    <input
        id="uploadFile"
        type="file"
        accept="image/png,image/jpeg"
        style="display: none;"
        @change="onFileChange"
    />

    <!-- 选择地区 -->
    <van-popup v-model="areasPicker.show" position="bottom" :lazy-render="false">
      <van-picker
              ref="areasPicker"
              show-toolbar
              :columns="areasPicker.columns"
              @cancel="areasPicker.show = false"
              @change="onAreasPickerChange"
              @confirm="onAreasPickerConfirm"
      />
    </van-popup>
    <certification v-if="isVerify" @close="isVerify = false;loadData()"></certification>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Button, Cell, CellGroup, ActionSheet, Field, Popup, Picker, Tag, Toast, Dialog } from 'vant';
  import Decimal from 'decimal.js';
  import moment from 'moment';
  import areas from '_pub/static/areas'
  import lrz from 'lrz'
  import { getClerk, updateConstellation, updateSound, updateName, updateSex, updateAge, updateSignature, updateAvatar, updateRegion, updatePaymentCode} from '@/api/clerk/clerk'
  import certification from "@/views/certification";
  import {getShopSetting} from "@/api/global";

  Vue.use(Button)
        .use(Cell)
        .use(CellGroup)
        .use(ActionSheet)
        .use(Field)
        .use(Popup)
        .use(Picker)
        .use(Tag)
        .use(Toast)
        .use(Dialog)

  export default {
    name: 'ClerkInfo',
    components:{
      certification,
    },
    data () {
      return {
        isVerify: false,
        file:null,
        codeType: null,
        model: null,
        clerkSoundIds: [],
        hasSoundList: null,
        statusMap: {
          1: '在线',
          2: '离线'
        },
        statusActionSheet: {
          show: false,
          actions: [
            { name: '在线 - 开启语音', value: '1-1', color: '#07c160' },
            { name: '在线 - 关闭语音', value: '1-0', color: '#ff9900' },
            { name: '离线', value: '2-0', color: 'gray' }
          ],
          selected: null
        },
        sexActionSheet: {
          show: false,
          actions: [],
          selected: null
        },
        constellationActionSheet: {
          show: false,
          actions: [],
          selected: null
        },
        updateNameDialog: {
          show: false,
          name: null
        },
        updateAgeDialog: {
          show: false,
          age: null
        },
        updateSignatureDialog: {
          show: false,
          signature: null
        },
        updateAvatarDialog: {
          show: false,
          avatar: null
        },
        areasPicker: {
          show: false,
          columns: [
            {
              values: []
            },
            {
              values: []
            }
          ]
        },
        fileChangeCallBack: null,
        areaProvinceList: areas[86],
        iconAudio: require("@/assets/images/icon_audio.png"),
        iconAudioPlaying: require("@/assets/images/icon_audio_playing.gif"),
        player: {
          id: null,
          audio: null
        },
        // 是否能修改
        isEdit: true,
        checkClerkSex:null
      }
    },
    methods: {
      //点击修改性别
      clickUpdateSex(){
        if (this.isEdit){
          this.sexActionSheet.show = true
        }
      },
      openVerify(){
        if(this.model.requireVerify){
          if(!this.model.isVerified){
            this.isVerify = true
          }else{
            Dialog.alert({
              title: '您已认证'
            })
          }
        }

      },
      formatDate(date, format) {
        if (!date) {
          return '';
        }
        if (!format) {
          format = 'YYYY-MM-DD'
        }
        return moment(date).format(format);
      },
      formatPrice(price) {
        if (price != null) {
          return Decimal.div(price, 100).toString()
        }
        return ''
      },
      onSexActionSheetSelect(item) {
        this.sexActionSheet.selected = item.value
        this.sexActionSheet.show = false;
        this.updateSex()
      },
      onConstellationActionSheetSelect(item) {
        this.constellationActionSheet.selected = item.value
        this.constellationActionSheet.show = false;
        this.updateConstellation()
      },
      onUpdateNameDialogClose(action, done) {
        if (action == 'confirm') {
          if (this.updateNameDialog.name == null || this.updateNameDialog.name == '') {
            Toast('名称不能为空');
            return done(false)
          }
          if (this.updateNameDialog.name != null && this.updateNameDialog.name.length > 10) {
            Toast('名称不能超过10个字');
            return done(false)
          }
          updateName(this.updateNameDialog.name).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              this.loadData()
              Dialog.alert({
                title: '修改昵称成功'
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改昵称失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      onUpdateAgeDialogClose(action, done) {
        if (action == 'confirm') {
          if (this.updateAgeDialog.age == null || this.updateAgeDialog.age == '') {
            Toast('年龄不能为空');
            return done(false)
          }
          if (this.updateAgeDialog.age < 1 || this.updateAgeDialog.age > 100) {
            Toast('年龄只能在1-100之间');
            return done(false)
          }
          updateAge(this.updateAgeDialog.age).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              this.loadData()
              Dialog.alert({
                title: '修改年龄成功'
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改年龄失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      onUpdateSignatureDialogClose(action, done) {
        if (action == 'confirm') {
          if (this.updateSignatureDialog.signature == null || this.updateSignatureDialog.signature == '') {
            Toast('个性签名不能为空');
            return done(false)
          }
          if (this.updateSignatureDialog.signature != null && this.updateSignatureDialog.signature.length > 30) {
            Toast('个性签名不能超过30个字');
            return done(false)
          }
          updateSignature(this.updateSignatureDialog.signature).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              this.loadData()
              Dialog.alert({
                title: '提交成功'
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改个性签名失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      getCityColumnValues(provinceCode) {
        const citys = areas[provinceCode]
        let values = []
        if (citys) {
          for (const key in citys) {
            values.push({
              text: citys[key],
              value: key
            })
          }
        }
        return values
      },
      onAreasPickerChange(picker, value, index) {
        if (index == 0) {
          picker.setColumnValues(1, this.getCityColumnValues(value[0].value));
        }
      },
      onAreasPickerConfirm(value, index) {
        const vm = this
        if (!value) {
          return Toast('请选择地区')
        }
        let regionNames = [value[0].text, value[1].text]
        let regionCodes = [value[0].value, value[1].value]

        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        updateRegion(
          JSON.stringify(regionNames),
          JSON.stringify(regionCodes)
        ).then(res => {
          Toast.clear()
          vm.areasPicker.show = false
          const data = res.data;
          if (data.code == 0) {
            this.model.regionNames = regionNames
            this.model.regionCodes = regionCodes
            Dialog.alert({
              title: '修改地区成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改地区失败',
              message: data.msg
            })
          }
        })
      },
      chooseImage(callback) {
        this.fileChangeCallBack = callback;
        document.getElementById("uploadFile").click();
      },

      onFileChange(e) {
        let vm = this;
        const file = e.target.files[0];
        document.getElementById("uploadFile").value = null;
        // 压缩图片
        lrz(file, {
          width: 800
        }).then(function (res) {
          console.log(res)
          vm.fileChangeCallBack(res)
        })
      },
      changeAvatar(res){
        this.updateAvatarDialog.avatar = res.base64
        this.updateAvatarDialog.show = true
      },
      updatePaymentCode(res){
        if (res.base64 == null) {
          Toast('请上传收款码');
          return;
        }
        const qrcode = res.base64;
        Toast.loading({
          mask: true,
          message: '上传收款码中'
        })
        updatePaymentCode(this.codeType,qrcode.split(',')[1]).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.loadData()
            Dialog.alert({
              title: '修改收款码成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改收款码失败',
              message: data.msg
            })
          }
        })

      },
      updateAvatar(action, done) {
        if (action == 'confirm') {
          if (this.updateAvatarDialog.avatar == null) {
            Toast('请上传头像');
            return done(false)
          }
          const avatar = this.updateAvatarDialog.avatar;
          Toast.loading({
            mask: true,
            message: '上传头像中'
          })
          updateAvatar(avatar.split(',')[1]).then(res => {
            Toast.clear()
            const data = res.data;
            if (data.code == 0) {
              this.loadData()
              Dialog.alert({
                title: '提交成功'
              })
            } else {
              this.loadData()
              Dialog.alert({
                title: '修改头像失败',
                message: data.msg
              })
            }
          })
          done()
        } else {
          done()
        }
      },
      updateSex() {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        updateSex(this.sexActionSheet.selected).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model.sex = this.sexActionSheet.selected
            Dialog.alert({
              title: '修改性别成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改性别失败',
              message: data.msg
            })
          }
        })
      },
      updateConstellation() {
        Toast.loading({
          mask: true,
          message: '请稍候...'
        })
        updateConstellation(this.constellationActionSheet.selected).then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model.constellation = this.constellationActionSheet.selected
            Dialog.alert({
              title: '修改星座成功'
            })
          } else {
            this.loadData()
            Dialog.alert({
              title: '修改星座失败',
              message: data.msg
            })
          }
        })
      },
      playAudio(id, audioUrl) {
        if (this.player.audio != null) {
          this.player.audio.pause()
        }
        if (this.player.id == id) {
          this.player.id = null
          this.player.audio = null
        } else {
          const audio = new Audio(audioUrl)
          audio.play()
          // 播放结束事件
          audio.onended = () => {
            this.player.id = null
            this.player.audio = null
          }
          this.player.id = id
          this.player.audio = audio
        }
      },
      loadData() {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        getClerk().then(res => {
          Toast.clear()
          const data = res.data;
          if (data.code == 0) {
            this.model = data.clerk;
            // 判断店铺是否要实名 判断店铺是否开启自动更新店员年龄个性别 判断店员是否已经实名
            if(this.model.requireVerify && this.checkClerkSex && this.model.isVerified) {
              // 如果店铺要求实名且店员已经实名，则不允许修改
              this.isEdit = false
            }
            this.clerkSoundIds = data.clerk.soundIds
            this.hasSoundList = data.hasSoundList
          } else {
            Dialog.alert({
              title: '加载失败',
              message: data.msg
            })
          }
        })
      },
      // 拿到店铺 的资料
      getShopSettings(){
        getShopSetting().then(res=>{
          const data= res.data;
          if(data.code==0){
            const setting = data.setting;
            this.checkClerkSex = setting.verify.checkClerkSex;
          }else{
            Dialog.alert({
              title: '获取店铺资料失败',
              message: data.msg
            })
          }
        })
      },
    },
    activated() {
      this.loadData()
    },
    mounted() {

      // 性别上拉菜单选项
      const sexList = this.$store.state.ClerkSexEnum.list()
      let sexActionSheetActions = []
      for (const item of sexList) {
        sexActionSheetActions.push({
          name: item.label,
          value: item.value
        })
      }
      this.sexActionSheet.actions = sexActionSheetActions

      // 星座上拉菜单选项
      const constellationList = this.$store.state.ConstellationEnum.list()
      let constellationActionSheetActions = []
      for (const item of constellationList) {
        constellationActionSheetActions.push({
          name: item.label,
          value: item.value
        })
      }
      this.constellationActionSheet.actions = constellationActionSheetActions

      // 地区picker选项
      const provinceMap = areas[86]
      let provinceColumnValues = []
      for (const key in provinceMap) {
        provinceColumnValues.push({
          text: provinceMap[key],
          value: key
        })
      }
      let cityColumnValues = this.getCityColumnValues(provinceColumnValues[0].value)
      const areasPicker = this.$refs.areasPicker
      areasPicker.setColumnValues(0, provinceColumnValues);
      areasPicker.setColumnValues(1, cityColumnValues);
    },
    updated() {
      // 统一替换标签
      this.$replaceLabel(document.body, this.$store.state.label, true)
    }
  }
</script>

<style lang="less" scoped>
    .upload-img-preview {
        width: 200px;
        height: 200px;
        object-fit: contain;
        background: #e5e5e5;
        border-radius: 4px;
    }

    .btn-play-audio {
        img {
            height: 20px;
        }
    }

    /deep/.van-cell__value{
      display: block;
      justify-content: flex-end;
      align-items: center;
    }
</style>
